import { useFaireDirectBrand } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { useIsLoggedInRetailerOrBrandPreview } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useSetting, useAssignSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { FAIRE_DIRECT_PDP_SIGN_UP_240808 } from "@faire/web-api--source/indigofair/settings/FAIRE_DIRECT_PDP_SIGN_UP_240808";
export var useSettingFaireDirectPDPSignup = function() {
    var settingValue = useSetting(FAIRE_DIRECT_PDP_SIGN_UP_240808, false);
    var isFaireDirectActiveInLoggedOut = useFaireDirectBrand().isFaireDirectActiveInLoggedOut;
    var isLoggedInRetailerOrBrandPreview = useIsLoggedInRetailerOrBrandPreview();
    return !isLoggedInRetailerOrBrandPreview && isFaireDirectActiveInLoggedOut && settingValue;
};
export var useAssignSettingFaireDirectPDPSignup = function() {
    return useAssignSetting(FAIRE_DIRECT_PDP_SIGN_UP_240808);
};
